export default __webpack_public_path__ + "378e8f9ed6d8fe325dc55a4cc40ac1a5.png";